import React from 'react';
import ReactDOM from 'react-dom';
import './i18n';
import AppManuals from './components/AppManuals';
import EifuAdmin from './components/EifuAdmin';

// React 17 render API. The HTML template renders into `.content-wrapper`
// to match the shared theme markup used by the homepage.
//
// Lightweight path routing (no router dependency): the /admin path renders the
// country-visibility admin console; everything else renders the public portal.
// Access to /admin is gated upstream by Cloudflare Access (Entra SSO); this code
// only decides which view to mount.
const isAdmin = window.location.pathname.replace(/\/+$/, '').endsWith('/admin');

ReactDOM.render(
  <React.StrictMode>{isAdmin ? <EifuAdmin /> : <AppManuals />}</React.StrictMode>,
  document.querySelector('.content-wrapper')
);
